import { produce } from "immer";
import {
  FETCH_MEDICATION,
  FETCH_MEDICATION_SUCCESS,
  FETCH_MEDICATION_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_MEDICATION,
  ADD_MEDICATION_SUCCESS,
  ADD_MEDICATION_FAILURE,
  //
  EDIT_MEDICATION,
  EDIT_MEDICATION_SUCCESS,
  EDIT_MEDICATION_FAILURE,
  //
  DELETE_MEDICATION,
  DELETE_MEDICATION_SUCCESS,
  DELETE_MEDICATION_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingMedication: false,
  medication: {},
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentMedication: {},
  // Delete
  isDeleting: false,
};

const ResidentMedicationReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_MEDICATION:
        draft.isFetchingMedication = true;
        break;
      case FETCH_MEDICATION_SUCCESS:
        draft.isFetchingMedication = false;
        // If loading more pages (page > 1), append data to existing data
        if (
          action.payload?.current_page > 1 &&
          draft.medication?.data &&
          Array.isArray(draft.medication.data) &&
          Array.isArray(action.payload.data)
        ) {
          draft.medication = {
            ...action.payload,
            data: [...draft.medication.data, ...action.payload.data],
          };
        } else {
          // First page or initial load - replace data
          draft.medication = action.payload;
        }
        break;
      case FETCH_MEDICATION_FAILURE:
        draft.medication = {};
        draft.isFetchingMedication = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentMedication = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentMedication = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_MEDICATION:
        draft.isSubmitting = true;
        break;
      case ADD_MEDICATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_MEDICATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_MEDICATION:
        draft.isSubmitting = true;
        break;
      case EDIT_MEDICATION_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_MEDICATION_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_MEDICATION:
        draft.isDeleting = true;
        break;
      case DELETE_MEDICATION_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_MEDICATION_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default ResidentMedicationReducer;
